// extracted by css-extract-rspack-plugin
export default {"image":"image--IdSo0qp57sLbJEZD"};